const SEO_LOCALES = [
  { code: "lt", language: "lt", ogLocale: "lt_LT" },
  { code: "en", language: "en", ogLocale: "en_US" },
  { code: "ru", language: "ru", ogLocale: "ru_RU" },
] as const;

const DEFAULT_SEO_LOCALE = "lt" as const;

export function useLocalizedSeoLinks(basePath: string) {
  const runtimeConfig = useRuntimeConfig();
  const localeRoute = useLocaleRoute();
  const { locale } = useI18n();

  const siteUrl = String(runtimeConfig.public.siteUrl || "")
    .trim()
    .replace(/\/+$/, "");

  const localizedUrls = computed(() =>
    SEO_LOCALES.map(item => {
      const path = localeRoute(basePath, item.code)?.path || basePath;

      return {
        ...item,
        url: `${siteUrl}${path}`,
      };
    }),
  );

  const currentLocale = computed(
    () =>
      SEO_LOCALES.find(item => item.code === locale.value) || SEO_LOCALES[0],
  );

  const canonicalUrl = computed(
    () =>
      localizedUrls.value.find(item => item.code === currentLocale.value.code)
        ?.url || `${siteUrl}${basePath}`,
  );

  const defaultUrl = computed(
    () =>
      localizedUrls.value.find(item => item.code === DEFAULT_SEO_LOCALE)?.url ||
      `${siteUrl}${basePath}`,
  );

  useHead(() => ({
    htmlAttrs: {
      lang: currentLocale.value.language,
    },
    link: [
      { rel: "canonical", href: canonicalUrl.value },
      ...localizedUrls.value.map(item => ({
        rel: "alternate",
        hreflang: item.language,
        href: item.url,
      })),
      {
        rel: "alternate",
        hreflang: "x-default",
        href: defaultUrl.value,
      },
    ],
  }));

  return {
    canonicalUrl,
    currentLocale,
  };
}
